<template>
  <LoaderCar v-if="loading" width="600px" marginTop="0" />
  <div class="dossier-select" v-else>
    <div class="header-select">
      <div class="greeting">
        <p><span @click="goToHome" style="cursor:pointer">Accueil</span> > Dossier</p>
        <h1>Gestion Dossier</h1>
        <p>Choisissez un élève et construisez son dossier</p>
      </div>
      <div class="info-container">
        <div class="info-trigger" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
          <img class="iconInfo" src="../../../assets/images/iconinfo.png" alt="Informations" />
          <transition name="tooltip-fade">
            <div class="tooltip-box" v-if="showTooltip">
              <div class="tooltip-header">
                <span>Gestion des pièces</span>
              </div>
              <ul class="tip-list">
                <li><span class="tip-icon ti-blue">1</span> Cliquez sur une pièce pour la télécharger et la visionner sur votre PC.</li>
                <li><span class="tip-icon ti-amber">2</span> Pensez à déplacer la pièce dans le dossier de l'élève sur votre PC.</li>
                <li><span class="tip-icon ti-green">3</span> En acceptant un document, vous validez la pièce entière.</li>
                <li><span class="tip-icon ti-red">4</span> S'il manque une partie de la pièce, cliquez sur Refuser et précisez la partie manquante.</li>
                <li><span class="tip-icon ti-purple">5</span> Vous pouvez aussi valider une pièce directement sans l'avoir acceptée au préalable — ex : pièce non applicable.</li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
      
      <div class="info-select">
        <div class="top">
          <p class="name-student">
            {{ student.prenom }} {{ student.nom.toUpperCase() }}
          </p>
          <button class="primary" @click="goToEleve()">ELEVE</button>
          <button class="danger" @click="goBackDossier">X</button>
        </div>
        <div class="bottom">
          <label for="saisi"
            >Saisi
            <input
              type="checkbox"
              name="saisi"
              id="saisi"
              v-model="eleve.dossier.ants"
              @change="clickSaisi()"
              :disabled="isWorkingSaisi"
          /></label>
          <div class="neph">
            <input
              type="text"
              name="neph"
              id="neph"
              placeholder="Saisir le numero NEPH"
              :disabled="isWorkingNeph"
              v-model="eleve.dossier.numNeph"
            />
            <button :disabled="isWorkingNeph" @click="clickNeph">></button>
            <button
              v-if="eleve.dossier.numNeph"
              class="delete-neph"
              :disabled="isWorkingNeph"
              @click="clickDeleteNeph"
              title="Supprimer le numéro NEPH"
            >
              🗑
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="piece-select">
        <template v-for="item in $store.state.dossier.pieceJustificatives" :key="item.id">
            <PieceJustif status="incomplet" :piece="item" :student="eleve" @unsetSaisi="eleve.dossier.ants = false"/>
        </template>
    </div>

    <Dialog
      v-model:visible="showNephDialog"
      modal
      :showHeader="false"
      :style="{ width: '500px', maxWidth: '95vw' }"
      :breakpoints="{ '575px': '95vw' }"
    >
      <div class="neph-dialog">
        <div class="neph-dialog__icon">
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <h3 class="neph-dialog__title">{{ eleve.prenom }} {{ eleve.nom.toUpperCase() }}</h3>
        <p class="neph-dialog__desc">
          <span class="neph-dialog__warning">ATTENTION</span>, vous allez saisir le NEPH de <strong>{{ eleve.prenom }} {{ eleve.nom.toUpperCase() }}</strong>.<br /><br />
          Une fois le NEPH saisi, toutes les pièces seront supprimées et le dossier sera finalisé sans possibilité de correction.<br /><br />
          Souhaitez-vous finaliser le dossier de <strong>{{ eleve.prenom }} {{ eleve.nom.toUpperCase() }}</strong> ?
        </p>
        <div class="neph-dialog__actions">
          <button class="neph-btn neph-btn--primary" @click="confirmNeph">OUI</button>
          <button class="neph-btn neph-btn--ghost" @click="cancelNephDialog">NON</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>

import PieceJustif from "../../eleve/dossier/PieceJustif.vue";
import LoaderCar from "../../LoaderCar.vue";


export default {
  props: ["student", "cancelSelect"],

  components: {
    LoaderCar,
    PieceJustif
  },

  data() {
    return {
      eleve: null,
      loading: true,
      isWorkingSaisi: false,
      isWorkingNeph: false,
      showTooltip: false,
      showNephDialog: false,
    };
  },

  mounted() {
    this.loadDossier();
  },

  methods: {
    goToHome() {
      this.$router.push({ name: "Home" });
    },

    async loadDossier() {
      this.eleve = this.student;
      try {
        // Charge les types de pièces justificatives pour pouvoir recalculer les pièces de l'utilisateur
        window.api
          .get("/type_piece_justificative", {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            // Place dans le store les types de pièce justificatives
            this.$store.state.typePieceJustificative =
              response.data["hydra:member"];
            // Si l'utilisateur a un dossier
            if (this.eleve.dossier !== null) {
              // Charge le dossier pour pouvoir recalculer les pièces de l'utilisateur
              window.api
                .get("/dossiers/" + this.eleve.dossier.id, {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                })
                .then((response) => {
                  // Place le dossier dans le store
                  this.$store.state.dossier = response.data;
                  let typePieces = this.getTypePiecesForDossier(
                    this.$store.state.dossier,
                  );
                  // Mise à jour des pièces relatives à l'utilisateur
                  window.api
                    .post(
                      "/dossier/piece",
                      {
                        dossier: this.$store.state.dossier,
                        typePieces: typePieces,
                      },
                      {
                        headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                        },
                      },
                    )
                    .then((response) => {
                      // Place dans le store le dossier après mise à jour des pièces
                      this.$store.state.dossier = response.data;
                      this.loadDossierFinish = true;
                    })
                    .catch((error) => {
                      // En cas d'échec de mise à jour des pièces, retour au menu home
                      this.$router.push({ name: "Home" });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  // En cas d'échec du chargement du dossier, retour au menu home
                  this.$router.push({ name: "Home" });
                  console.log(error.response.data.message);
                });
            } else {
              // Sinon, retour au menu home
              this.$router.push({ name: "Home" });
            }

            setTimeout(() => {
              this.loading = false;
            }, "1000");
          })
          .catch((error) => {
            // En cas d'échec au chargement des types de pièce justificatives, retour au menu home
            this.$router.push({ name: "Home" });
            console.log(error.response.data.message);
          });
      } catch (e) {
        // En cas d'erreur, retour au menu home
        this.$router.push({ name: "Home" });
      }
    },

    goBackDossier() {
      this.$emit("cancelSelect");
    },

    goToEleve() {
      this.$router.push({
        name: "AgenceEleveSelec",
        params: { id: this.eleve.id },
      });
    },

    getTypePiecesForDossier(dossier) {
      // Initialisation de typePieces avec les pièces permanente
      let typePieces = this.$store.state.typePieceJustificative.filter(
        (el) => el.useCase === "dossier",
      );
      // Calcul de l'age
      let birthDate = new Date(dossier.dateNaissance);
      let today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      // Suivant des conditions, différents type de pièce sont ajoutés à typePieces

      // Si l'élève a entre 17 ans inclus et 25 ans exclu
      if (age >= 17 && age < 25) {
        Array.prototype.push.apply(
          typePieces,
          this.$store.state.typePieceJustificative.filter(
            (el) => el.useCase === "age",
          ),
        );
      }
      // Si la demande fait suite à une annulation/invalidation de permis
      if (dossier.faitSuite) {
        Array.prototype.push.apply(
          typePieces,
          this.$store.state.typePieceJustificative.filter(
            (el) => el.useCase === "faitSuite",
          ),
        );
        // Si l'annulation/invalidation est lié à l'alcool ou la drogue
        if (dossier.motifAlcoolStup) {
          Array.prototype.push.apply(
            typePieces,
            this.$store.state.typePieceJustificative.filter(
              (el) => el.useCase === "faitSuite/oui",
            ),
          );
        } else {
          Array.prototype.push.apply(
            typePieces,
            this.$store.state.typePieceJustificative.filter(
              (el) => el.useCase === "faitSuite/non",
            ),
          );
        }
      }

      return typePieces;
    },

    clickSaisi() {
      // Indique l'enregistrement de la saisi du dossier sur ANTS
      this.isWorkingSaisi = true;
      // Mise à jour du dossier
      window.api
        .patch(
          "/dossiers/" + this.eleve.dossier.id,
          {
            ants: this.eleve.dossier.ants,
            status: "Saisi",
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          },
        )
        .then(() => {
          if (this.eleve.dossier.ants === true) {
            window.api
              .post(
                "/sendMail",
                {
                  type: "dossier saisi",
                  email: this.eleve.email,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {})
              .catch((error) => {
                console.log(error);
              });
          }

          // Indique que l'enregistrement de la saisi du dossier sur ANTS est terminé
          this.isWorkingSaisi = false;
          this.setStatusDossier();
        })
        .catch((error) => {
          // Indique que l'enregistrement de la saisi du dossier sur ANTS est terminé
          this.isWorkingSaisi = false;
          console.log(error);
        });
    },

    clickNeph() {
      // Ouvre le dialog de confirmation du numéro NEPH
      this.showNephDialog = true;
    },

    cancelNephDialog() {
      this.showNephDialog = false;
    },

    confirmNeph() {
      this.showNephDialog = false;
      this.isWorkingNeph = true;
      // Modifi le numéro en base de données
      window.api
          .patch(
            "/dossiers/" + this.eleve.dossier.id,
            {
              numNeph: this.eleve.dossier.numNeph,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            },
          )
          .then(() => {
            this.setStatusDossier();
            // Envoi un mail — désactivé temporairement (à réactiver plus tard)
            // window.api
            //   .post(
            //     "/sendMail",
            //     {
            //       type: "dossier valide",
            //       email: this.eleve.email,
            //     },
            //     {
            //       headers: {
            //         Authorization: "Bearer " + this.$store.state.token,
            //       },
            //     },
            //   )
            //   .then(() => {})
            //   .catch((error) => {
            //     console.log(error);
            //   });
            // Lance la deletion des pièces en base de données
            window.api
              .post(
                "/dossier/deletePiece",
                {
                  dossier: this.eleve.dossier,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {
                this.isWorkingNeph = false;
                this.$emit("cancelSelect");
              });
          })
          .catch((error) => {
            // Indique que l'enregistrement du numéro NEPH est terminé
            this.isWorkingNeph = false;
            console.log(error);
          });
    },

    clickDeleteNeph() {
      this.isWorkingNeph = true;

      if (
        window.confirm(
          "Voulez-vous vraiment supprimer le numéro NEPH ? Les pièces du dossier seront également supprimées.",
        )
      ) {
        window.api
          .patch(
            "/dossiers/" + this.eleve.dossier.id,
            {
              numNeph: "",
              ants: false,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
              },
            },
          )
          .then(() => {
            this.eleve.dossier.numNeph = "";
            this.eleve.dossier.ants = false;
            // Lance la deletion des pièces en base de données
            window.api
              .post(
                "/dossier/deletePiece",
                {
                  dossier: this.eleve.dossier,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {
                // Recrée les pièces justificatives, comme pour un dossier Incomplet normal
                let typePieces = this.getTypePiecesForDossier(
                  this.eleve.dossier,
                );
                window.api
                  .post(
                    "/dossier/piece",
                    {
                      dossier: this.eleve.dossier,
                      typePieces: typePieces,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    },
                  )
                  .then((response) => {
                    let dossierWithPieces = response.data;
                    let pieces = dossierWithPieces.pieceJustificatives;

                    // Valide chaque pièce, comme le fait le bouton "valider" sur une pièce
                    Promise.all(
                      pieces.map((piece) =>
                        window.api.patch(
                          "/piece_justificatives/" + piece.id,
                          { etat: true },
                          {
                            headers: {
                              Authorization:
                                "Bearer " + this.$store.state.token,
                              "Content-Type": "application/merge-patch+json",
                            },
                          },
                        ),
                      ),
                    )
                      .then(() => {
                        pieces.forEach((piece) => {
                          piece.etat = true;
                        });
                        this.$store.state.dossier = dossierWithPieces;
                        this.eleve.dossier.statutDossier = "Validées";
                        this.isWorkingNeph = false;
                        this.setStatusDossier();
                      })
                      .catch((error) => {
                        this.isWorkingNeph = false;
                        console.log(error);
                      });
                  })
                  .catch((error) => {
                    this.isWorkingNeph = false;
                    console.log(error);
                  });
              });
          })
          .catch((error) => {
            this.isWorkingNeph = false;
            console.log(error);
          });
      } else {
        this.isWorkingNeph = false;
      }
    },

    setStatusDossier() {
      window.api
        .post(
          "/update/uneleve/dossier/" + this.eleve.id,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then(() => {
          this.getElevesDossier(this.offsetTable, "null", "null");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
div.dossier-select {
  width: 70%;
  margin: auto;
  margin-top: 4rem;
  text-align: left;
}

div.header-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.dossier-select div.greeting p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

div.dossier-select div.greeting h1 {
  font-weight: bold;
}

div.dossier-select div.info-select {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: box-shadow 0.2s;
  padding: 20px;
}

div.dossier-select div.info-select div.top {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 1rem;
}

div.dossier-select div.info-select div.bottom {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
}

div.dossier-select div.info-select div.bottom input {
  background-color: #f4f6f9;
  border: 1px solid #e5ebf2;
  border-radius: 5px;
}

div.dossier-select div.info-select div.bottom button {
  border: 1px solid #e5ebf2;
  border-radius: 5px;
  background-color: #f4f6f9;
}

div.dossier-select div.info-select div.bottom button.delete-neph {
  color: #f43f5e;
  border-color: #fecdd3;
  background-color: #fff1f2;
  cursor: pointer;
}

div.dossier-select div.info-select div.bottom button.delete-neph:hover {
  background-color: #f43f5e;
  color: white;
}

div.dossier-select div.info-select div.top p {
  font-size: 20px;
  margin: auto;
  font-weight: bold;
}

div.dossier-select div.info-select div.top button {
  border: none;
  border-radius: 5px;
  padding: 10px;
}

div.dossier-select div.info-select div.top button.primary {
  background-color: #3b82f6;
  color: white;
}

div.dossier-select div.info-select div.top button.primary:hover {
  background-color: white;
  color: #3b82f6;
  border: 1px solid #3b82f6;
}

div.dossier-select div.info-select div.top button.info {
  background-color: #3bc1f6;
  color: white;
}

div.dossier-select div.info-select div.top button.info:hover {
  background-color: white;
  color: #3bc1f6;
  border: 1px solid #3bc1f6;
}

div.dossier-select div.info-select div.top button.danger {
  background-color: #f43f5e;
  color: white;
}

div.dossier-select div.danger-select div.top button.danger:hover {
  background-color: white;
  color: #f43f5e;
  border: 1px solid #f43f5e;
}

div.dossier-select div.info-select div.top button:active {
  transform: translateY(-4px);
}

div.piece-select{
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 2 colonnes */
    gap: 10px; 
    margin-top: 3rem;
}

img.iconInfo{
  width: 50px;
}

div.info-container { position: relative; }
.info-trigger { position: relative; display: inline-block; cursor: default; }
.tooltip-box {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 300px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.10);
  padding: 14px 16px;
  z-index: 999;
  font-size: 12.5px;
  color: #374151;
}
.tooltip-header {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #3b82f6;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}
.tip-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 8px; }
.tip-list li { display: flex; align-items: flex-start; gap: 8px; line-height: 1.5; }
.tip-icon { display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 6px; font-size: 11px; font-weight: 700; flex-shrink: 0; }
.ti-blue   { background: #eff6ff; color: #3b82f6; }
.ti-amber  { background: #fef3c7; color: #d97706; }
.ti-green  { background: #ecfdf5; color: #059669; }
.ti-red    { background: #fff1f2; color: #f43f5e; }
.ti-purple { background: #f5f3ff; color: #7c3aed; }
.tooltip-fade-enter-active, .tooltip-fade-leave-active { transition: opacity 0.18s, transform 0.18s; }
.tooltip-fade-enter-from, .tooltip-fade-leave-to { opacity: 0; transform: translateY(-4px); }

/* ── Dialog confirmation NEPH ── */
.neph-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 24px;
  gap: 12px;
}

.neph-dialog__icon {
  width: 56px;
  height: 56px;
  background: #fef3c7;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f59e0b;
  flex-shrink: 0;
}

.neph-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1f2e;
  margin: 4px 0 0;
  text-transform: uppercase;
}

.neph-dialog__desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  max-width: 380px;
  margin: 0;
}

.neph-dialog__warning {
  color: #f43f5e;
  font-weight: 700;
}

.neph-dialog__actions {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.neph-btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 24px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.neph-btn--ghost {
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
}

.neph-btn--ghost:hover {
  background: #f8fafc;
}

.neph-btn--primary {
  background: #3b82f6;
  color: #fff;
}

.neph-btn--primary:hover {
  background: #2563eb;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1024px) {
  div.dossier-select {
    width: 90%;
    margin-top: 2rem;
  }

  div.piece-select {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  div.dossier-select {
    width: 100%;
    padding: 0 14px;
    box-sizing: border-box;
    margin-top: 1.5rem;
  }

  /* Header : empile greeting / icône info / info-select verticalement */
  div.header-select {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }

  /* Cache l'icône info sur mobile (tooltip hover inutilisable) */
  div.info-container {
    display: none;
  }

  /* Info-select : top en colonne sur très petit écran */
  div.dossier-select div.info-select div.top {
    flex-wrap: wrap;
    gap: 10px;
  }

  div.dossier-select div.info-select div.top p {
    font-size: 16px;
    flex: 1 1 100%;
  }

  /* Bottom : champ NEPH prend toute la largeur */
  div.dossier-select div.info-select div.bottom {
    flex-wrap: wrap;
    gap: 10px;
  }

  div.neph {
    flex: 1 1 100%;
    display: flex;
    gap: 6px;
  }

  div.neph input {
    flex: 1;
    min-width: 0;
  }

  /* Pièces : 1 colonne */
  div.piece-select {
    grid-template-columns: 1fr;
    margin-top: 1.5rem;
  }

  /* Tooltip en position fixe sur mobile pour éviter le débordement */
  .tooltip-box {
    position: fixed;
    top: auto;
    bottom: 16px;
    right: 16px;
    left: 16px;
    width: auto;
  }
}
</style>
